<template>
  <div class="cavani_tm_section" id="anais">
    <div class="section_inner">
      <div class="cavani_tm_newss">
        <div class="cavani_tm_title">
          <span>Anais</span>
        </div>
        <div class="news_list">
          <ul>
            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/documentos/anais/capa/1.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/documentos/anais/capa/1.jpg'"></div>
                  <a class="cavani_tm_full_link" :href="'site/documentos/anais/Anais_IMostra.pdf'" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category"><a :href="'site/documentos/anais/Anais_IMostra.pdf'">Anais</a></span>
                      <span class="date">Vol 1, 2012</span>
                    </div>
                    <div class="title">
                      <h3><a href="#">Anais I Mostra de Iniciação Científica no Pantanal</a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/documentos/anais/capa/2.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/documentos/anais/capa/2.jpg'"></div>
                  <a class="cavani_tm_full_link" :href="'site/documentos/anais/Anais_IIMostra.pdf'" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category"><a :href="'site/documentos/anais/Anais_IIMostra.pdf'">Anais</a></span>
                      <span class="date">Vol 2, 2013</span>
                    </div>
                    <div class="title">
                      <h3><a href="#">Anais II Mostra de Iniciação Científica no Pantanal</a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/documentos/anais/capa/3.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/documentos/anais/capa/3.jpg'"></div>
                  <a class="cavani_tm_full_link" :href="'site/documentos/anais/Anais_IIIMostra.pdf'" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category"><a :href="'site/documentos/anais/Anais_IIIMostra.pdf'">Anais</a></span>
                      <span class="date">Vol 3, 2014</span>
                    </div>
                    <div class="title">
                      <h3><a href="#">Anais III Mostra de Iniciação Científica no Pantanal</a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/documentos/anais/capa/4.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/documentos/anais/capa/4.jpg'"></div>
                  <a class="cavani_tm_full_link" :href="'site/documentos/anais/Anais_IVMostra.pdf'" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category"><a :href="'site/documentos/anais/Anais_IVMostra.pdf'">Anais</a></span>
                      <span class="date">Vol 4, 2015</span>
                    </div>
                    <div class="title">
                      <h3><a href="#">Anais IV Mostra de Iniciação Científica no Pantanal</a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/documentos/anais/capa/5.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/documentos/anais/capa/5.jpg'"></div>
                  <a class="cavani_tm_full_link" :href="'site/documentos/anais/Anais_VMostra.pdf'" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category"><a :href="'site/documentos/anais/Anais_VMostra.pdf'">Anais</a></span>
                      <span class="date">Vol 5, 2016</span>
                    </div>
                    <div class="title">
                      <h3><a href="#">Anais V Mostra de Iniciação Científica no Pantanal</a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/documentos/anais/capa/6.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/documentos/anais/capa/6.jpg'"></div>
                  <a class="cavani_tm_full_link" href="https://drive.google.com/file/d/1hJyp4MxuNmfK4Yh_SjOaiggNdr46QDuf/view" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category"><a href="https://drive.google.com/file/d/1hJyp4MxuNmfK4Yh_SjOaiggNdr46QDuf/view">Anais</a></span>
                      <span class="date">Vol 6, 2017</span>
                    </div>
                    <div class="title">
                      <h3><a href="#">Anais VI Mostra de Iniciação Científica no Pantanal</a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/documentos/anais/capa/7.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/documentos/anais/capa/7.jpg'"></div>
                  <a class="cavani_tm_full_link" href="https://drive.google.com/file/d/1IqhDy4gYaW7rRaUAwotqFAPSyDag6GRY/view" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category"><a href="https://drive.google.com/file/d/1IqhDy4gYaW7rRaUAwotqFAPSyDag6GRY/view">Anais</a></span>
                      <span class="date">Vol 7, 2018</span>
                    </div>
                    <div class="title">
                      <h3><a href="#">Anais VII Mostra de Iniciação Científica no Pantanal</a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/documentos/anais/capa/8.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/documentos/anais/capa/8.jpg'"></div>
                  <a class="cavani_tm_full_link" href="https://drive.google.com/file/d/1PJ8nbGrvOUvp0DTm4gshJsMK_XO7FP8H/view" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category"><a href="https://drive.google.com/file/d/1PJ8nbGrvOUvp0DTm4gshJsMK_XO7FP8H/view">Anais</a></span>
                      <span class="date">Vol 8, 2019</span>
                    </div>
                    <div class="title">
                      <h3><a href="#">Anais VIII Mostra de Iniciação Científica no Pantanal</a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/documentos/anais/capa/9.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/documentos/anais/capa/9.jpg'"></div>
                  <a class="cavani_tm_full_link" href="https://drive.google.com/file/d/1HHHcePPwGEQq8pBtxTDSy1kvxML9KD-P/view" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category"><a href="https://drive.google.com/file/d/1HHHcePPwGEQq8pBtxTDSy1kvxML9KD-P/view">Anais</a></span>
                      <span class="date">Vol 9, 2022</span>
                    </div>
                    <div class="title">
                      <h3><a href="#">Anais IX Mostra de Iniciação Científica no Pantanal</a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li>
              <div class="list_inner">
                <div class="image">
                  <img :src="'site/documentos/anais/capa/10.jpg'" alt="" />
                  <div class="main" :data-img-url="'site/documentos/anais/capa/10.jpg'"></div>
                  <a class="cavani_tm_full_link" href="https://drive.google.com/file/d/1NCSskava31L6Sw39FiK5AEnjeHy9UM0C/view" target="_blank"></a>
                </div>
                <div class="details">
                  <div class="metabox">
                    <div class="info">
                      <span class="category"><a href="https://drive.google.com/file/d/1NCSskava31L6Sw39FiK5AEnjeHy9UM0C/view">Anais</a></span>
                      <span class="date">Vol 10, 2023</span>
                    </div>
                    <div class="title">
                      <h3><a href="#">Anais X Mostra de Iniciação Científica no Pantanal</a></h3>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
